import { Tile, TileState } from './Tile';
import type { FiardleGuessData } from '@/lib/api';

interface GameBoardProps {
  guesses: FiardleGuessData[];
  currentGuess: string;
  maxGuesses?: number;
  wordLength?: number;
}

export function GameBoard({
  guesses,
  currentGuess,
  maxGuesses = 6,
  wordLength = 5,
}: GameBoardProps) {
  const rows: { letter: string; state: TileState }[][] = [];

  // Submitted guesses
  for (const guess of guesses) {
    const row = guess.word.split('').map((letter, i) => ({
      letter,
      state: guess.result[i] as TileState,
    }));
    rows.push(row);
  }

  // Current guess row (if game is still in progress)
  if (guesses.length < maxGuesses) {
    const currentRow = Array.from({ length: wordLength }, (_, i) => ({
      letter: currentGuess[i] || '',
      state: (currentGuess[i] ? 'active' : 'empty') as TileState,
    }));
    rows.push(currentRow);
  }

  // Empty remaining rows
  while (rows.length < maxGuesses) {
    rows.push(
      Array.from({ length: wordLength }, () => ({
        letter: '',
        state: 'empty' as TileState,
      })),
    );
  }

  return (
    <div className="flex flex-col gap-1 items-center" data-testid="game-board">
      {rows.map((row, rowIdx) => (
        <div key={rowIdx} className="flex gap-1">
          {row.map((tile, colIdx) => (
            <Tile key={colIdx} letter={tile.letter} state={tile.state} />
          ))}
        </div>
      ))}
    </div>
  );
}
